export default crypto;
export const isCryptoKey = (key) => key instanceof CryptoKey;



// WEBPACK FOOTER //
// ./~/jose/dist/browser/runtime/webcrypto.js